import { useCallback, useEffect } from 'react';

const usePostMessage = (message: string, receiveMessageHandler?: () => void) => {
  const messageListener = useCallback(
    ({ data }: MessageEvent) => {
      if (data === message) {
        if (typeof receiveMessageHandler === 'function') {
          receiveMessageHandler();
        }
      }
    },
    [message, receiveMessageHandler]
  );

  useEffect(() => {
    window.addEventListener('message', messageListener);
    return () => window.removeEventListener('message', messageListener);
  }, [messageListener]);

  return {
    postMessage: () => {
      if (window.opener != null) {
        const openerWindow = window.opener as Window;
        openerWindow.postMessage(message, '*');
      }
    },
  };
};

export default usePostMessage;
